<template>
  <div class="card">
    <div class="card-header ps-7 pe-5">
      <h3 class="card-title align-items-start flex-column">
        {{ translate("action_locaion_list_header") }}
        <span class="text-muted mt-1 fw-bold fs-7"
          >{{ records }} {{ translate("Records_Found") }}</span
        >
      </h3>
    </div>

    <div class="card-body">
      <DataTable
        :value="actionAuditList"
        dataKey="Id"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        v-model:filters="filters"
        filterDisplay="row"
        :globalFilterFields="['beginDate', 'locationId']"
        :lazy="true"
        :loading="loading"
        :paginator="false"
        :totalRecords="totalRecords"
        removableSort
        class="rounded"
        responsiveLayout="scroll"
      >
        <Column headerStyle="width: 1em"></Column>

        <Column
          field="locationId"
          :header="translate('audit_planning_list_location')"
          :showFilterMenu="false"
          sortable
        >
          <template #body="{ data }">
            <span :class="'customer-badge status-' + data.LocationName">{{
              data.LocationName
            }}</span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @change="filterCallback()"
              :options="actionLocationList"
              :placeholder="translate('Search')"
              class="p-column-filter form-control p-0"
              :showClear="true"
            >
              <template #value="slotProps">
                <span
                  :class="'customer-badge status-' + slotProps.value"
                  v-if="slotProps.value"
                  >{{ slotProps.value.Value }}</span
                >

                <span v-else>{{ slotProps.placeholder }}</span>
              </template>
              <template #option="slotProps">
                <span
                  :class="'customer-badge status-' + slotProps.option.Value"
                  >{{ slotProps.option.Value }}</span
                >
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column
          field="BeginDate"
          :header="translate('audit_planning_list_audit_date')"
          filterField="beginDate"
          filterMatchMode="contains"
          ref="beginDate"
          :sortable="true"
          style="max-width: 500px"
        >
          <template #filter="{ filterModel, filterCallback }">
            <input
              v-model="filterModel.value"
              name="beginDate"
              type="date"
              @change="filterCallback()"
              class="p-column-filter form-control form-control-sm pe-8"
              :placeholder="translate('Search')"
              @keyup="inputNull($event)"
              dateFormat="yy.mm.dd"
            />
          </template>
        </Column>

        <Column field="Id" :rowEditor="true" bodyStyle="text-align:center">
          <template #body="{ data }">
            <div class="d-flex justify-content-end">
              <router-link
                v-if="userGuard(permissionActions.value)"
                :to="`/auditactions/actiondetail/${data.Id}`"
              >
                <a
                  :title="translate('Detail')"
                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                >
                  <span class="svg-icon svg-icon-3">
                    <inline-svg src="media/icons/duotune/abstract/abs015.svg" />
                  </span>
                </a>
              </router-link>
              <div v-else class="h-40px"></div>
            </div>
          </template>
        </Column>
      </DataTable>
      <div class="mt-5">
        <Pagination @onPage="onPage" :TotalData="records" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useConfirm } from "primevue/useconfirm";
import { userGuard } from "@/store/utils/userGourad";

//Store Tanımlaması
const store = useStore();
const confirm = useConfirm();
//Router Tanımlaması
const router = useRouter();

// Multi Language
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const totalRecords = ref(0);
const lazyParams = ref({
  page: 1,
  pageSize: 10,
  actionRequiredOnly: true,
  sortColumn: null,
  sortDirection: null,
  locationId: 0,
  beginDate: null,
});

const getAction = (payload) => {
  store.dispatch("AuditPlanningModule/GET_ALL_AUDIT_PLANNING", payload);
};

const actionAuditList = computed(
  () => store.getters["AuditPlanningModule/_getAuditList"]
);

const loading = computed(
  () => store.getters["AuditPlanningModule/_getLoading"]
);
const records = computed(
  () => store.getters["AuditPlanningModule/_getTotalRecords"]
);

const categoryList = ref([]);

const getActionLocation = () => {
  store.dispatch("ActionModule/GET_LOCATION_BY_USER");
};

getActionLocation();
const actionLocationList = computed(
  () => store.getters["ActionModule/_getActionLocation"]
);

//Data Table Filter Tanımlaması
const filters = ref({
  locationId: { value: null, matchMode: "contains" },
  beginDate: { value: null, matchMode: "contains" },
});

// Data Table Eventları
const onPage = (e) => {
  lazyParams.value.page = e.step.value;
  lazyParams.value.pageSize = e.pageSize.value;
  getAction(lazyParams.value);
};

const onSort = (event) => {
  lazyParams.value.sortColumn = event.sortField;
  lazyParams.value.sortDirection = event.sortOrder === 1 ? "asc" : "desc";
  getAction(lazyParams.value);
};

const onFilter = () => {
  lazyParams.value.beginDate = filters.value.beginDate.value;
  if (filters.value.locationId.value === null) {
    lazyParams.value.locationId = 0;
  } else {
    lazyParams.value.locationId = filters.value.locationId.value.Id;
  }

  getAction(lazyParams.value);
};

const inputNull = (event) => {
  if (event.target.value === "") {
    lazyParams.value[event.target.name] = "";
    getAction(lazyParams.value);
  }
};
const permissionActions = ref("Actions");

watch(locale, () => {
  setCurrentPageBreadcrumbs(translate("action_audit_list"), [
    translate("Menu_Audit"),
  ]);
});

onMounted(() => {
  setCurrentPageBreadcrumbs(translate("action_audit_list"), [
    translate("Menu_Audit"),
  ]);
});

getAction(lazyParams.value);
</script>
